import {
  isEmpty,
  isNil,
  isBoolean,
  head,
  toPairs,
  intersection,
  omit,
  keys,
  findIndex,
} from 'lodash-es';

import {
  RULES,
  VALIDATION_ERRORS,
  REQUIRED_ERRORS,
  WITHOUT_VALIDATION,
  MAX_LENGTH,
  MAX_LENGTH_ERRRORS,
} from './constants';

export const maxLength = (entries) => {
  const [key, value] = entries;

  if (!MAX_LENGTH[key]) {
    return;
  }

  return value.length > MAX_LENGTH[key] ? MAX_LENGTH_ERRRORS[key] : undefined;
};

export const isValidField = (entries) => {
  const [key, value] = entries;

  if (key === 'attachment' && value.size >= 26214400) {
    return "File's size too large. Max available file size is 25 MB.";
  }

  if (key === 'attachment') {
    return findIndex(RULES[key], (ext) => value.name.endsWith(ext)) >= 0
      ? undefined
      : VALIDATION_ERRORS[key];
  }

  if (key === 'email' && value.length > 254) {
    return 'Email is too long (max is 254 character).';
  }

  if (key === 'email' && value.length < 5) {
    return 'Email is too short';
  }

  if (key === 'password' && value.length < 6) {
    return 'Please enter at least 6 characters.';
  }

  if (key === 'password' && value.length > 255) {
    return 'Max password length is 255 characters.';
  }

  if (!RULES[key]) {
    return;
  }

  return value.match(RULES[key]) ? undefined : VALIDATION_ERRORS[key];
};

export const required = (entries) => {
  const [key, value] = entries;

  if (isBoolean(value)) {
    return value ? undefined : REQUIRED_ERRORS[key];
  }

  if (key === 'attachment') {
    return !value ? REQUIRED_ERRORS[key] : undefined;
  }

  if (isEmpty(value)) {
    return REQUIRED_ERRORS[key];
  }

  if (isEmpty(value.trim())) {
    return REQUIRED_ERRORS[key];
  }
};

export const composeValidators = (...validators) => (value) =>
  validators.reduce((error, validator) => error || validator(value), undefined);

export const basicValidation = composeValidators(
  required,
  isValidField,
  maxLength
);

export const validateValues = (values) => {
  const toValidate = omit(
    values,
    intersection(keys(values), WITHOUT_VALIDATION)
  );

  const errors = toPairs(toValidate).map((entries) => {
    const error = basicValidation(entries);
    return isNil(error)
      ? {}
      : {
          [head(entries)]: error,
        };
  });
  return errors.reduce((prev, curr) => ({ ...prev, ...curr }), {});
};
